import { memo } from 'react'
import { ErrorMessage, Field, FieldProps as FormikFieldProps } from 'formik'
import { useIntl } from 'react-intl'
import has from 'lodash/has'

import {
  CommonStyledTextArea,
  StyledInputError,
  StyledInputLabelWrapper,
  StyledInputLabel,
} from 'components/Input/styles'
import { CustomFieldProps } from '../types'
import { textAreaMessages } from './messages'

function TextArea({ showLabel = false, inputId, ...props }: CustomFieldProps) {
  const { formatMessage } = useIntl()
  const { name, placeholder, rows } = props
  return (
    <Field name={name}>
      {({ field, form: { errors, touched } }: FormikFieldProps) => (
        <>
          {showLabel && field?.value && (
            <StyledInputLabelWrapper>
              <StyledInputLabel htmlFor={inputId || name}>
                {placeholder}
              </StyledInputLabel>
            </StyledInputLabelWrapper>
          )}
          <CommonStyledTextArea
            id={inputId || name}
            rows={rows}
            placeholder={
              placeholder || `${formatMessage(textAreaMessages.placeholder)}`
            }
            invalid={has(errors, name) && has(touched, name)}
            {...field}
            {...props}
          />
          <StyledInputError>
            <ErrorMessage name={name} />
          </StyledInputError>
        </>
      )}
    </Field>
  )
}

export default memo(TextArea)
